import { ListWithPagination } from 'dash-ui';
import styled from 'styled-components';

export const StyledList = styled(ListWithPagination)`
  & > div:first-child {
    padding: 0;
    border: none;
  }
  & > div:last-child {
    justify-content: center;
  }
`;
